<ion-header>
	<ion-row>
		<ion-col class="ion-no-padding" size="12" size-lg="12">
			<div class="venue_info_block">
				<ion-icon (click)="goBack()" class="back-icon" src="../../../assets/topgolf/blue-back-arrow.svg"></ion-icon>
				<div class="logo-wrapper">
					<ion-icon class="logo" src="../../../assets/topgolf/header_logo.svg"></ion-icon>
				</div>
				<div class="right-slot">
					@if (order?.orderedArticles?.length > 0) {
					<ion-button (click)="toggleBasket(modalCtrl)" class="show-basket">
						<ion-icon src="../../../assets/topgolf/Orders_Pink.svg"></ion-icon>
						<h4>{{ numberToCurrency(orderTotalPrice(order, true, true, null), order.currency) }}</h4>
					</ion-button>
					}
					<app-burger-btn></app-burger-btn>
				</div>
			</div>
		</ion-col>
	</ion-row>

	<ion-row class="search-row">
		<ion-col class="ion-no-padding" size="12">
			<div class="search-bar-wrapper">
				<div class="search-bar-inner">
					<img class="search-icon" src="../../../assets/icon/Search.svg" [alt]="'menu_page.search_alt' | translate" />
					<input
						class="search-input"
						type="text"
						[attr.placeholder]="'menu_page.search_input' | translate"
						[value]="searchQuery"
						(input)="onSearchChange($event)"
					/>
					@if (searchQuery) {
					<button class="search-clear" (click)="searchQuery = ''; reloadCategories()">✕</button>
					}
				</div>
			</div>
		</ion-col>
	</ion-row>

	<ion-row>
		<ion-col class="ion-no-padding" size="12">
			<div class="main-category-list">
				@for (tagCategory of mainTagCategories; track tagCategory.tag) {
				<ion-chip
					(click)="selectMainCategory(tagCategory.tag)"
					[class.selected]="tagCategory.tag === selectedMainCategory"
					class="chip main-category"
					tappable
				>
					<img [src]="tagCategory.icon" alt="Category Icon" />
					<p>{{ tagCategory.name | langObservable | async }}</p>
				</ion-chip>
				}
			</div>
		</ion-col>
	</ion-row>

	<ion-row>
		<ion-col class="ion-no-padding display-flex" size="12">
			@if (selectedMainCategory === ArticleCategoryType.BEVERAGE && subCategoriesMap[selectedMainCategory]?.length > 0) {
			<div #drinkSubcategoryList class="category-list">
				<ng-container *ngTemplateOutlet="subCatTemplate"></ng-container>
			</div>
			} @else if (selectedMainCategory === ArticleCategoryType.OTHER && subCategoriesMap[selectedMainCategory]?.length > 0) {
			<div #retailSubcategoryList class="category-list">
				<ng-container *ngTemplateOutlet="subCatTemplate"></ng-container>
			</div>
			} @else if (selectedMainCategory === ArticleCategoryType.PROMOS && subCategoriesMap[selectedMainCategory]?.length > 0) {
			<div #promoSubcategoryList class="category-list">
				<ng-container *ngTemplateOutlet="subCatTemplate"></ng-container>
			</div>
			} @else {
			<div #categoryList class="category-list">
				@for (category of categories; track category._id; let categoryIndex = $index) {
				<ion-chip
					(click)="scrollTo(categoryIndex)"
					[class.selected]="selectedCategory?._id === category._id"
					class="chip category ion-margin-top ion-margin-bottom"
					tappable
				>
					<p>{{ category.name | langObservable | async }}</p>
				</ion-chip>
				}
			</div>
			}
		</ion-col>
	</ion-row>
</ion-header>

<ng-template #subCatTemplate>
	@for (subCategory of subCategoriesMap[selectedMainCategory]; track subCategory.identifier) {
	<ion-chip
		(click)="toggleSubCategory(selectedMainCategory, subCategory.identifier)"
		[class.selected]="selectedSubCategoryMap[selectedMainCategory] === subCategory.identifier"
		class="chip category ion-margin-top ion-margin-bottom"
		tappable
	>
		<p>{{ subCategory.name | langObservable | async }}</p>
	</ion-chip>
	}
</ng-template>

<ion-content>
	<ion-row class="main_row">
		<ion-col class="catalog_col" size="12" sizeLg="12" sizeMd="12">
			<ion-content #articleContent (ionScroll)="onScroll($event)" [scrollEvents]="scrollEvents" class="main-content">
				@if (categories?.length === 0) {
				<div class="no_items">
					<p>{{ 'menu_page.no_articles' | translate }}</p>
				</div>
				} @for (category of categories; track trackByCategory($index, category)) {
				<ion-row class="item_row">
					<ion-row class="category-row">
						<h2>{{ category.name | langObservable | async }}</h2>
						<div class="divider-name"></div>
					</ion-row>

					@for (article of category.articles; track trackBy($index, article)) {
					<ion-col class="ion-no-padding item-col" size="6" sizeLg="4" sizeXl="3">
						<app-item-view
							(addToBasketCustomizeEvent)="openModal(article, category, true)"
							(addToBasketEvent)="addToBasket(modalCtrl, repository, article, category)"
							(removeArticleFromBasket)="removeBasket(repository, $event)"
							[article]="article"
							[categoryName]="category.name.de"
							[currency]="order?.currency"
							[hasOrder]="!!order"
							[orderValue]="order"
							[preorderType]="null"
							[selectedToggleTag]="selectedToggleTag"
							class="item-responsive"
						>
						</app-item-view>
					</ion-col>
					} @if ($last) {
					<div class="padding-80 more"></div>
					}
				</ion-row>
				}
			</ion-content>
		</ion-col>
	</ion-row>
	<div [class.show-item]="showMessageNotification" class="fixed-notification">{{ messageNotification }}</div>
</ion-content>

@if (!categories) {
<ion-content>
	<ion-row class="center">
		<ion-spinner name="crescent"></ion-spinner>
	</ion-row>
</ion-content>
}
<app-floating-cart-button (onClick)="toggleBasket(modalCtrl)" [order]="order"></app-floating-cart-button>
